"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crud = void 0;
var http_1 = require("../http");
var abstract_crud_1 = require("./abstract.crud");
var Crud = /** @class */ (function (_super) {
    __extends(Crud, _super);
    function Crud() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.http = http_1.http;
        return _this;
    }
    return Crud;
}(abstract_crud_1.AbstractCrud));
exports.Crud = Crud;



//////////////////
// WEBPACK FOOTER
// /home/node/app/~/entcore-toolkit/dist/crud/crud.js
// module id = 14
// module chunks = 0 1